module.exports = __webpack_public_path__ + "static/media/Регламент_работы_стендовой_сессии_1.a857a14d.pdf";